import { useSelector } from "react-redux";
import { useGetSummaryReports } from "../ServerSideStates";
import { RootState } from "store/Reducers";
import {  Row,  } from "antd";
import { useEffect, useState } from "react";
import SummaryItem from "./SummaryItem";
import SummaryReportSkeleton from "apps/Common/Skelton/SummaryReport/SummaryReportSkelton";

const ListItems = () => {
  const { filter } = useSelector((state: RootState) => state.summaryReport);
  const summaryReport = useGetSummaryReports(filter);
  const [data,setData] = useState<any[]>([])
  useEffect(()=>{
    if(summaryReport?.data)
    {
        const dbSummaryValues:any = summaryReport?.data?.data
        let boxData = [
            {
                src:"https://cdn-icons-png.flaticon.com/512/1997/1997928.png",
                title:"Toplam Verilen İlan Sayısı",
                value:dbSummaryValues?.totalAdvertCount,
                suffix:"ilan"
            },
            {
                src:"https://cdn-icons-png.flaticon.com/512/5656/5656148.png",
                title:"İlan Başına Görüntüleme Sayısı",
                value:dbSummaryValues?.averageViewPerAdvert,
                 suffix:"Görüntüleme"
            },
            {
                src:"https://cdn-icons-png.flaticon.com/512/13804/13804149.png",
                title:"İlan Başına Toplam Arama/Mesaj Sayısı",
                value:dbSummaryValues?.totalMessageCount,
                 suffix:"Adet"
            },
            {
                src:"https://cdn-icons-png.flaticon.com/512/11434/11434861.png",
                title:"Toplam Favoriye Ekleme",
                value:dbSummaryValues?.totalFavoriteCount,
                 suffix:"Adet"
            },
            {
                src:"https://cdn-icons-png.flaticon.com/512/2782/2782058.png",
                title:"Ziyaretçi",
                value:dbSummaryValues?.totalVisitorCount,
                 suffix:"Kişi"
            },
        ]

        setData(boxData)
    }

  },[summaryReport.data])
  return (
    <>
    <SummaryReportSkeleton
    rowCount={2}
    colCount={3}
    isLoading={summaryReport?.isLoading||summaryReport.isFetching}
    >

   <Row gutter={[20, 20]}>
      {data.map((item, index) => (
        <SummaryItem key={index} {...item} />
      ))}
    </Row>
    </SummaryReportSkeleton>
    </>
  );
};

export default ListItems;
